import React from "react";
import { Edit, SimpleForm } from 'react-admin';

import { SaveWithCancelToolbar } from '../../../components/toolbars/SaveWithCancelToolbar';
import { ThirdPartyAppForm } from "../Form/Form";
import { transformThirdPartyApp } from "../Form/transform";
import { ThirdPartyAppStatusActions } from "./ThirdPartyAppStatusActions";


export const ThirdPartyAppEdit = (props) => (
	<Edit {...props} undoable={false} transform={transformThirdPartyApp}>
		<SimpleForm submitOnEnter={false} toolbar={<SaveWithCancelToolbar><ThirdPartyAppStatusActions /></SaveWithCancelToolbar>}>
			<ThirdPartyAppForm isAddForm={false} />
		</SimpleForm>
	</Edit>
);
